module.exports = __webpack_public_path__ + "img/Teaching-Research Case - Blue - Selected.0125c1cf.png";